/**
 * FOSSA Global Typographic Variables
 */
export const fossaPrimaryFont = `'Open Sauce Two', 'Open Sauce', 'Helvetica Neue', Helvetica, Arial, sans-serif`;
export const fossaSecondaryFont = `'Open Sauce Two Medium', 'Open Sauce', 'Helvetica Neue', Helvetica, Arial, sans-serif`;
